// todo
export const logacyAppUrl = process.env.VUE_APP_LEGACY_URL;
